import { Component, ViewEncapsulation } from '@angular/core';

/**
 * Cooperative "Roadmap" section: a static marketing / concept-preview panel
 * (no controller logic) showcasing upcoming Nurturing and Community features.
 */
@Component({
  selector: 'ft-cooperative-roadmap-ng',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./cooperative-roadmap.component.scss'],
  templateUrl: './cooperative-roadmap.component.html',
})
export class CooperativeRoadmapComponent {}
